/** @jsx jsx */

import { useMemo } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import getAllInteractions, {
  ONLY_TOPICS_NOT_HIDDEN_FROM_NEXT_AND_BACK_NAVIGATION,
} from 'services/apiHelpers/getAllInteractions';
import { useSelector } from 'react-redux';

const { lGrey0 } = colors;

const ProgressBar = ({ color = lGrey0 }) => {
  const interactionsSeen = useSelector((state: any) => {
    return state.interactionsSeen;
  });
  const allInteractions = useMemo(() => {
    return getAllInteractions(
      ONLY_TOPICS_NOT_HIDDEN_FROM_NEXT_AND_BACK_NAVIGATION
    );
  }, []);

  const percent = (
    (interactionsSeen.length / allInteractions.length) *
    100
  ).toFixed();

  return (
    <div
      role="progressbar"
      aria-valuenow={Number(percent)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Module progress (%)"
      css={css`
        position: relative;
        width: 100%;
        height: 10px;
        border: 1px solid ${color};
        border-radius: 5px;
        overflow: hidden;
      `}
    >
      <div
        css={css`
          position: absolute;
          left: 0px;
          top: 0px;
          width: ${percent}%;
          height: 10px;
          background: ${color};
          transition: width 0.2s;
        `}
      />

      <span className="sr-only">Progress: {percent}%</span>
    </div>
  );
};

export default ProgressBar;
